import { DEFAULT_EXCHANGE_DATA } from '../config'

import { currenciesMap } from 'utils/currency-helper'

export const getCurrenciesFromSlug = (): { baseCurrency: string; counterCurrency: string } => {
  const segments = window.location.pathname.split('/').filter(Boolean)
  const lastSegment = segments[segments.length - 1] ?? ''
  const parts = lastSegment.split('-')

  if (parts.length === 2) {
    const base = parts[0].toUpperCase()
    const counter = parts[1].toUpperCase()

    if (base in currenciesMap && counter in currenciesMap) {
      return { baseCurrency: base, counterCurrency: counter }
    }
  }

  console.warn('Could not parse currencies from slug, using default values')

  return {
    baseCurrency: DEFAULT_EXCHANGE_DATA.baseCurrency,
    counterCurrency: DEFAULT_EXCHANGE_DATA.counterCurrency,
  }
}
